const productsData = [
    {
        id: 1,
        image: require('@/assets/images/products/2.jpg'),
        name: 'Gray belt watch',
        discount: '24 % Off',
        color: 'primary',
        oldprice: '$72',
        newprice: '$64'
    },
    {
        id: 2,
        image: require('@/assets/images/products/2.jpg'),
        name: 'Riverston Glass Chair',
        discount: '26 % Off',
        color: 'danger',
        oldprice: '$70',
        newprice: '$62'
    },
    {
        id: 3,
        image: require('@/assets/images/products/3.jpg'),
        name: 'Trex Outdoor Furniture Cape',
        discount: '30 % Off',
        color: 'warning',
        oldprice: '$78',
        newprice: '$68'
    },
    {
        id: 4,
        image: require('@/assets/images/products/4.jpg'),
        name: '3 color belt watch',
        discount: '28 % Off',
        color: 'success',
        oldprice: '$84',
        newprice: '$72'
    },
    {
        id: 5,
        image: require('@/assets/images/products/5.jpg'),
        name: 'Classic Company watch',
        discount: '30 % Off',
        color: 'success',
        oldprice: '$70',
        newprice: '$68'
    },
    {
        id: 6,
        image: require('@/assets/images/products/6.jpg'),
        name: 'Shine Company Chair',
        discount: '32 % Off',
        color: 'warning',
        oldprice: '$84',
        newprice: '$68'
    },
    {
        id: 7,
        image: require('@/assets/images/products/7.jpg'),
        name: 'Trex Outdoor Furniture Cape',
        discount: '34 % Off',
        color: 'danger',
        oldprice: '$74',
        newprice: '$66'
    },
    {
        id: 8,
        image: require('@/assets/images/products/8.jpg'),
        name: 'black color lamp',
        discount: '26 % Off',
        color: 'primary',
        oldprice: '$72',
        newprice: '$64'
    },
];

export { productsData };
